import * as fromDatatype from '../datatype-library/index';

export interface bl_dgmkt_treatment_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  campaign_hdr_guid: fromDatatype.GuidDataFieldInterface;
  segment_guid: fromDatatype.GuidDataFieldInterface;
  template_message_guid: fromDatatype.GuidDataFieldInterface;
  schedule_guid: fromDatatype.GuidDataFieldInterface;
  endpoint_guid: fromDatatype.GuidDataFieldInterface;
  ref_treatment_id: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_updated: fromDatatype.TimestampTzDatatypeInterface;
}

export class bl_dgmkt_treatment_hdr_RowClass
  implements bl_dgmkt_treatment_hdr_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  campaign_hdr_guid: fromDatatype.GuidDataFieldInterface;
  segment_guid: fromDatatype.GuidDataFieldInterface;
  template_message_guid: fromDatatype.GuidDataFieldInterface;
  schedule_guid: fromDatatype.GuidDataFieldInterface;
  endpoint_guid: fromDatatype.GuidDataFieldInterface;
  ref_treatment_id: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_updated: fromDatatype.TimestampTzDatatypeInterface;
}
